import moment from "moment";

export const dateHyphen = (date: string | Date, format: string) => {
  const dateMoment = moment(date);
  return dateMoment.format(format);
}